import React from 'react';
import { RouteWithLayout } from 'components';
import { Minimal as MinimalLayout } from 'layouts';
import { Switch, Redirect } from 'react-router-dom';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const SignUpPage = React.lazy(() => import('./SignUp'));

const SignUpRoutes = () => {
  return (
    <Switch>
      <GoogleReCaptchaProvider
        reCaptchaKey={process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY}
      >
        <RouteWithLayout
          component={SignUpPage}
          exact
          isPrivate={false}
          layout={MinimalLayout}
          path="/sign-up"
        />
      </GoogleReCaptchaProvider>
      <Redirect to="/not-found" />
    </Switch>
  );
};

export default SignUpRoutes;
